import axios, { AxiosResponse } from 'axios';

export const order = {
  getOrderHistory: (count: number, payload): Promise<AxiosResponse> =>
    axios.get(`/orderhistory/orders?count=${count}`, payload),

  getFulfilmentStatus: (orderId: number): Promise<AxiosResponse> =>
    axios.get(`/order/fulfillmentstatus?orderId=${orderId}`),
};
